import { isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, OnChanges, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
//import {  } from '../../../Services/Form Data /form-data.service';
import { BCategoryFormComponent } from '../b-category-form/b-category-form.component';
import { FormDataService } from '../../../Services/Form Data/form-data.service';
import { DataService } from '../../../Services/Data Service/data.service';
import { firstValueFrom, forkJoin, switchMap, take } from 'rxjs';
import { AuthService } from '../../../Auth/auth.service';
import { FormUpdateService } from '../../../Services/Form Data/formupdate.service';
import { DisableAutocompleteDirective } from '../../../disable-autocomplete.directive';

declare var M: any;

@Component({
  selector: 'app-a-customer-info',
  standalone: true,
  imports: [FormsModule, NgIf, NgFor, BCategoryFormComponent, DisableAutocompleteDirective],
  templateUrl: './a-customer-info.component.html',
  styleUrl: './a-customer-info.component.css',
  providers: [BCategoryFormComponent]
})
export class ACustomerInfoComponent {
  @Input() isViewOnly: boolean = false;
  @Input() formData: any; 
  @Input() isOriginalSubmission: boolean = false;

  error_message = '';

  user: any;
  company: any;
  // subsidary = '';

  loading = false;
  // currUser: any;
  savedMessage = '';
  exists = false;
  maxDate: string;


  @ViewChild(BCategoryFormComponent) cCategoryForm!: BCategoryFormComponent;

  constructor(
    // @Inject(PLATFORM_ID) private platformId: Object,
    private formDataService: FormDataService,
    private formUpdateService: FormUpdateService,
    private dataService: DataService,
    private auth: AuthService
  ) {
    // console.log('User and Company:', JSON.stringify({ user: this.user, company: this.company }, null, 2));
    
    // Set maximum date to today using dataService
    const today = new Date(this.dataService.getLocalDate());
    this.maxDate = today.toISOString().split('T')[0];
  }

  ngOnInit(){
    this.user = this.formDataService.getUserData(); 
    this.company = this.formDataService.getCompanyData(); 
  }
  

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formData']){
      if (this.formData?.company) {
        this.company = this.formData.company;
      }
      if (this.formData?.user) {
        this.user = this.formData.user;
      }
    }
  }

  // ngAfterViewInit() {
  //   if (isPlatformBrowser(this.platformId)) {
  //     setTimeout(() => {
  //       const elems = document.querySelectorAll('select');
  //       M.FormSelect.init(elems);
  //     });
  //   }
  // }

  updateErrorMsg(error: string){
    this.error_message = error;
  }

  removeSize(): void {
    this.company.strnumEmployees = '';  
  }
  removeCountryReg(): void {
    this.company.strRegisteredCountry = '';  
  }
  removeCountryMail(): void {
    this.company.strMailingCountry = '';  
  }

  removeAffiliation():void {
    this.company.strAffiliation = '';
    this.company.strCompanyAffiliated = '';
    console.log(this.company.blnAffiliation);
  }

  countries: string[] = [
    "Trinidad and Tobago",
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
    "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
    "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
    "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
    "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada",
    "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros",
    "Congo (Congo-Brazzaville)", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia",
    "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
    "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini",
    "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
    "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
    "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
    "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan",
    "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania",
    "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands",
    "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro",
    "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
    "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan",
    "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland",
    "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
    "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia",
    "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands",
    "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname",
    "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste",
    "Togo", "Tonga", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda",
    "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
    "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
  ];

  subsidaries: string[] = [
    "UNIPET",
    "Unipet Energy",
    "Convenience Pay",
    "360-Total Convenience Limited",
    "Transport Division"
  ];

  //Field Validators
  validatefields(): boolean {
    console.log("User Data:", this.user);
    console.log("Company Data:", this.company);

    if (!this.user.strJobTitle?.trim()
      || !this.user.strContact?.trim()
      || !this.user.strEmail?.trim()
      || !this.user.strName?.trim()
      || !this.company.dteEstablished
      || !this.company.strnumEmployees?.trim()
      || !this.company.strCompanyName?.trim()
      || !this.company.strRegistrationNum?.trim()
      // || !this.company.strCompanyWebsite?.trim()
      || !this.company.strRegisteredAddress?.trim()
      ) {
      this.error_message = "All fields must be filled out."; 
      return false;
    }

    if (!this.company.strRegisteredCountry){
      this.error_message = "Please select a country for Registered Address."
      return false;
    }

    // Check if date business established is in the future
    const establishedDate = new Date(this.company.dteEstablished);
    const today = new Date(this.dataService.getLocalDate());
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    if (establishedDate > today) {
      this.error_message = "Date Business Established cannot be in the future.";
      return false;
    }

    const hasMailingCountry = !!this.company.strMailingCountry;
    const hasMailingAddress = !!this.company.strMailingAddress;

    if (hasMailingCountry !== hasMailingAddress) {
      this.error_message = "Mailing address incomplete.";
      return false;
    }

    if (!this.user.strContact?.trim()) { //phone number was never changed and validator not reached
      this.error_message = "Please enter a valid phone number.";
      return false;
    }
  
    if (this.company.blnAffiliation == true && !this.company.strAffiliation){
      this.error_message = "Please enter explanation for affiliation."
      return false;
    }


    this.error_message = "";
    return true;
  }

  validateEmail(email: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailPattern.test(email);
  
    if (!isValid) {
      this.error_message = "Invalid email format. Please enter a valid email.";
      return false;
    }
  
    this.error_message = "";
    return true;
  }
  


  validatePhoneNumber(input: string): void {
    // Remove all spaces
    const formattedInput = input.replace(/\s+/g, '');
  
    // Regular expression to match area code (3 digits) + 7 or 12 digits = 15 digits Maximum
    const phonePattern = /^\d{10,15}$/;
  
    if (!phonePattern.test(formattedInput)) {
      this.error_message = "Phone number must be 10-15 digits (area code + 7 digits, this must not exceed 15).";
      return;
    }
  
    // Assign the formatted value back (optional if you want to store it formatted)
    this.user.strContact = formattedInput; 
  
    this.error_message = "";
  }
  
  async onSubmit(): Promise<boolean> {
    if (!this.validatefields()) {
     return false; // Validation failed
    }
    if (this.error_message !== "") {
      return false; // Error message present, do not proceed
    }

    this.loading = true;
    this.error_message = "";

    const categorySubmitSuccess = await this.cCategoryForm.submit();
    if (!categorySubmitSuccess) {
      this.error_message = this.cCategoryForm.error || "Error. Ensure all details filled for Type of Business/Type of Organization";
      this.loading = false;
      return false;
    }    

    //updating form data which is used in formSubmitService
    this.formDataService.updateUserData({
      strJobTitle: this.user.strJobTitle,
      strContact: this.user.strContact,
      strEmail: this.user.strEmail,
      strName: this.user.strName
    });

    // this.formDataService.setAffiliatedSubsidary(this.subsidary);
    // this.formDataService.setCountryRegistered(this.company.strRegisteredCountry);
    // this.formDataService.setCountryMailing(this.company.strMailingCountry);
 
    this.formDataService.updateCompanyData({
      strCompanyName: this.company.strCompanyName,
      strCompanyWebsite: this.company.strCompanyWebsite,
      dteEstablished: this.company.dteEstablished,
      strRegistrationNum: this.company.strRegistrationNum,
      strnumEmployees: this.company.strnumEmployees,
      strMailingAddress: this.company.strMailingAddress,
      strRegisteredAddress: this.company.strRegisteredAddress,
      strMailingCountry: this.company.strMailingCountry,
      strRegisteredCountry: this.company.strRegisteredCountry,
      strAffiliation: this.company.strAffiliation,
      blnAffiliation: this.company.blnAffiliation,
      strCompanyAffiliated: this.company.strCompanyAffiliated
    });

    //UPDATE company and user in DB
    try {
      await firstValueFrom(forkJoin([
        this.formUpdateService.updateCompany(this.formDataService.getCurrCompanyID()),
        this.formUpdateService.updateUser(this.formDataService.getCurrCompanyID())
      ]));

       this.loading = false;
      return true;
    } catch (error) {
      this.error_message = "There was an issue saving. Please try again.";
      this.savedMessage = "";
      this.loading = false;
      return false;
    }
  }


  
}
